<template>
    <div>
        <modal class="bill-detail" :display="modalStatus.bizBillDetail" @modalStatus="closeModal" >
            <h1>查看帳單</h1>
            <div class="bill-detail-wrap" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                <div class="bill-info">
                    <span class="title">帳單金額</span>
                    <div class="tatal-amount">
                        {{toCurrency(billList.totalBillAmount)}}
                    </div>
                    <span class="state blue" v-if="billList.billStatus == 'COMPLETELY_PAID'">已繳</span>
                    <span class="state gray" v-if="billList.billStatus == 'UNPAID'">未繳</span>
                    <span class="state red" v-if="billList.billStatus == 'OVERDUE'">{{checkArrearsDay(billList.arrearsDay)}}</span>
                    <span class="state red" v-if="billList.billStatus == 'PARTIAL_PAID'">部分繳款</span>
                </div>
                <div class="list">
                    <span class="title">房源地址</span>
                    <span class="content">：{{billList.address}}</span>
                </div>
                <div class="list">
                    <span class="title">租客名稱</span>
                    <span class="content">：{{billList.tenantName}}</span>
                </div>
                <div class="list" v-if="billList.billName != '押金' && billList.billName != '訂金'">
                    <span class="title">繳款租期</span>
                    <span class="content">：{{billList.periodStartDate}} ～ {{billList.periodEndDate}}</span>
                </div>
                <!-- <div class="list" v-if="billList.billStatus == 'UNPAID'">
                    <span class="title">應收款日</span>
                    <span class="content">：{{billList.periodStartDate}}</span>
                </div> -->
                <div class="list" v-if="billList.billStatus == 'COMPLETELY_PAID'">
                    <span class="title">繳款日期</span>
                    <span class="content">：{{billList.actualPayTime}}</span>
                </div>
                <div class="list">
                    <span class="title">帳單名稱</span>
                    <span class="content">：{{billList.billName}}</span>
                </div>
                <div v-if="billList.rent" class="list">
                    <span class="title">租金</span>
                    <span class="content">
                        ：<span class="num">{{billList.rent?toCurrency(billList.rent):''}}</span>
                    </span>
                </div>
                <div v-if="billList.bookingDeposit" class="list">
                    <span class="title">訂金</span>
                    <span class="content">
                        ：<span class="num">{{billList.bookingDeposit?toCurrency(billList.bookingDeposit):''}}</span>
                    </span>
                </div>
                <div v-if="billList.contractDeposit" class="list">
                    <span class="title">押金</span>
                    <span class="content">
                        ：<span class="num">{{billList.contractDeposit?toCurrency(billList.contractDeposit):''}}</span>
                    </span>
                </div>
                <div v-if="billList.waterBill" class="list">
                    <span class="title">水費</span>
                    <span class="content num">：
                        <span class="num">{{billList.waterBill?toCurrency(billList.waterBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.electricityBill" class="list">
                    <span class="title">電費</span>
                    <span class="content">：
                        <span class="num">{{billList.electricityBill?toCurrency(billList.electricityBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.gasBill" class="list">
                    <span class="title">瓦斯費</span>
                    <span class="content">：
                        <span class="num">{{billList.gasBill?toCurrency(billList.gasBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.internetBill" class="list">
                    <span class="title">網路費</span>
                    <span class="content">：
                        <span class="num">{{billList.internetBill?toCurrency(billList.internetBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.tvBill" class="list">
                    <span class="title">有線電視</span>
                    <span class="content">：
                        <span class="num">{{billList.tvBill?toCurrency(billList.tvBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.repairBill" class="list">
                    <span class="title">修繕工程</span>
                    <span class="content">：
                        <span class="num">{{billList.repairBill?toCurrency(billList.repairBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.cleaningBill" class="list">
                    <span class="title">清潔費</span>
                    <span class="content">：
                        <span class="num">{{billList.cleaningBill?toCurrency(billList.cleaningBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.parkingBill" class="list">
                    <span class="title">停車費</span>
                    <span class="content">：
                        <span class="num">{{billList.parkingBill?toCurrency(billList.parkingBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.managementBill" class="list">
                    <span class="title">管理費</span>
                    <span class="content">：
                        <span class="num">{{billList.managementBill?toCurrency(billList.managementBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.otherBill" class="list">
                    <span class="title">其他</span>
                    <span class="content">：
                        <span class="num">{{billList.otherBill?toCurrency(billList.otherBill):''}}</span>
                    </span>
                </div>
                <div v-if="billList.billStatus == 'PARTIAL_PAID'" class="list" style="color:#ff9275">
                    <span class="title">已收款</span>
                    <span class="content">：
                        <span class="num">{{billList.paidAmount?toCurrency(billList.paidAmount):''}}</span>
                    </span>
                </div>
            </div>
            <div class="btn-group" v-if="billList.billStatus == 'OVERDUE'">
                <button class="default-button confirm" @click="sendMsg()">催款</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';

import { mapGetters } from 'vuex'

import { 
    apiBizGetBillDetail,
    apiSendMsg,
    apiBizHadSent
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            billList:{},
        }
    },
    props:{
        billSeq: null,
        phone: null
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch:{
        billSeq: function (val) {
            this.getBillDetail(val)
        },
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizBillDetail'})
        },
        getBillDetail: function (val) {
            let data = val
            apiBizGetBillDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.billList = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        sendMsg: function () {
            this.$analyticsBiz.logEvent('送出催款', { screen_name: '送出催款'})
            let data = {
                "account": this.phone,
                "title":"",
                "message":"您有一筆租金尚未繳款，請立即開啟確認"
            }

            apiSendMsg(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '催款訊息送出成功',type: 'success'})
                    this.setHadSent(this.billSeq)
                    this.closeModal()
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '催款訊息送出失敗',type: 'error'})
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setHadSent: function (billCid) {
            let data = {
                "billCid" : billCid,
                "hadSent" : true
            }

            apiBizHadSent(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.$store.dispatch('getFinancialBillMgtList')
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        checkArrearsDay: function (day) {
            if(day > 0){
                return '欠款'+day+'天'
            }else{
                return '欠款'
            }
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }else{
        //         return 0
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.bill-detail{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                }
                .bill-detail-wrap{
                    padding: 20px 32px 20px;
                    overflow-x: hidden;
                    max-height: 455px;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .bill-info{
                        position: relative;
                        display: flex;
                        align-items: center;
                        width: 384px;
                        height: 62px;
                        padding: 12px 16px;
                        margin-bottom: 25px;
                        border-radius: 6px;
                        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
                        border: solid 1px #f3f3f3;
                        background-color: #ffffff;
                        box-sizing: border-box;
                        .title{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-right: 20px;
                            color: #a19d9c;
                            border-right: 1px solid #f3f3f3;
                            height: 62px;
                        }
                        .tatal-amount{
                            padding-left: 20px;
                            letter-spacing: 0.22px;
                            color: #676362;
                            font-size: 20px;
                        }
                        .state{
                            position: absolute;
                            width: 76px;
                            height: 38px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 4px;
                            right: 20px;
                        }
                        .state.blue{
                            background-color: rgba(113, 170, 229, 0.1);
                            color: #71aae5;
                        }
                        .state.red{
                            background-color: rgba(240, 90, 62, 0.1);
                            color: #fc7171;
                        }
                        .state.gray{
                            background-color: #f3f3f3;
                            color: #676362;
                        }
                    }
                    .list{
                        display: flex;
                        margin-bottom: 8px;
                    }
                    .title{
                        width: 56px;
                        // color: #a8a5a4;
                        margin-right: 4px;
                        display: inline-flex;
                    }
                    .content{
                        display: flex;
                        .num{
                            display: block;
                            width: 51px;
                            text-align: right;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 424px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/BillDetail.vue